<template>
  <div id="footer">
    <div class="footer-info bg-secondary-dark">
      <div class="container">
        <div class="row">
          <div
            class="col-brand col-md-4 d-flex align-items-center justify-content-center my-40 my-md-0"
          >
            <router-link to="/">
              <img src="@/assets/image/logo-footer.png" />
            </router-link>
          </div>
          <div class="col-md-8 col-info">
            <div class="row">
              <div class="col-12">
                <div class="info">
                  <p>
                    客服時間為週一至週五
                    <br class="d-md-none" />上午09:00～下午18:00
                    <br />客服電話：02-8979-5558
                  </p>
                  <ul class="d-flex d-md-none align-items-center justify-content-center mt-30">
                    <li class="mr-25">
                      <router-link to="/">
                        <Icons name="facebook" />
                      </router-link>
                    </li>
                    <li class="mr-25">
                      <router-link to="/">
                        <Icons name="instagram" />
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/">
                        <Icons name="mail" />
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-md-4 col-6">
                <ul>
                  <li class="mb-10 text-center">
                    <router-link
                      :to="{name:'Service'}"
                      :class="{'active':this.$route.name==='Service'}"
                    >HS超集點</router-link>
                  </li>
                  <li class="mb-10 text-center">
                    <router-link
                      :to="{name:'Partners'}"
                      :class="{'active':this.$route.name==='Partners'}"
                    >合作商家</router-link>
                  </li>
                  <!-- <li class="mb-10 text-center">
                    <a
                      href="#"
                      @click.prevent="goToSection('Collaboration')"
                      :class="{'active':this.$route.name==='Collaboration'}"
                    >關係企業</a>
                  </li> -->
                  <!-- <li class="mb-10 text-center">
                    <router-link
                      :to="{name:'Related'}"
                      :class="{'active':this.$route.name==='Related'}"
                    >關係企業</router-link>
                  </li> -->
                </ul>
              </div>
              <div class="col-md-4 col-6">
                <ul>
                  <li class="mb-10 text-center">
                    <router-link :to="{name:'QA'}" :class="{'active':this.$route.name==='QA'}">常見問題</router-link>
                  </li>
                  <li class="mb-10 text-center">
                    <router-link
                      :to="{name:'Terms'}"
                      :class="{'active':this.$route.name==='Terms'}"
                    >使用者條款</router-link>
                  </li>
                  <li class="mb-10 text-center">
                    <router-link
                      :to="{name:'Privacy'}"
                      :class="{'active':this.$route.name==='Privacy'}"
                    >隱私權條例</router-link>
                  </li>
                </ul>
              </div>
              <div class="col-4 ml-auto d-none d-md-block">
                <ul class="d-flex align-items-center justify-content-between">
                  <li>
                    <a href="https://www.facebook.com/HSvibe/" target="_blank">
                      <Icons name="facebook" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/hs.vibe/" target="_blank">
                      <Icons name="instagram" />
                    </a>
                  </li>
                  <li>
                    <a href="mailto:hsvibe@hichi-tech.com">
                      <Icons name="mail" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="footer-bottom bg-primary text-white d-flex align-items-center justify-content-center py-30"
    >
      <p class="text-center">
        <small>COPYRIGHT @{{ new Date().getFullYear() }} HICHI-TECH CO., LTD</small>
      </p>
    </div>
  </div>
</template>
<script>
import Icons from '@/components/icon.vue';

export default {
  name: 'Footer',
  components: {
    Icons,
  },
  methods: {
    goToSection(section) {
      if (this.$route.name === 'Home') {
        this.$nextTick(() => {
          setTimeout(() => {
            this.$emit('goToSection', section);
          }, 800);
        });
      } else {
        this.$router.push({ name: 'Home', params: { section } });
      }
    },
  },
};
</script>
<style lang="scss">
#footer {
  font-weight: $font-weight-light;
  font-size: $font-size-sm;
  .footer-info {
    padding: 50px 0;
    .col-info {
      a,
      li,
      p {
        color: white;
        transition: 0.3s ease-out;
      }
      a:hover,
      a.active {
        color: $sub-primary;
        text-decoration: none;
        svg {
          transition: 0.3s ease-out;
          fill: $sub-primary;
        }
      }
      .info {
        border-bottom: 1px solid white;
        padding-bottom: 25px;
        margin-bottom: 25px;
        text-align: center;
        @media (min-width: 768px) {
          text-align: left;
        }
      }
    }
  }
}
</style>
